import { contactDisplayName } from '@/lib/contactDisplay';

/**
 * Stacked contact name display — company name on top + contact person
 * below for Commercial accounts, person name only for Residential.
 * Used anywhere a customer/contact is listed (Contacts, Projects, Estimates,
 * Invoices, Jobs, Permits) so "BuilderCake" is what jumps out, not "Valentina".
 */
export default function ContactNameStack({
  contact,
  className = '',
  primaryClassName = 'text-sm font-medium text-gray-900 truncate',
  secondaryClassName = 'text-xs text-gray-400 truncate',
  testId,
}) {
  const { primary, secondary } = contactDisplayName(contact);
  return (
    <div className={className} data-testid={testId}>
      <p className={primaryClassName}>{primary}</p>
      {secondary && <p className={secondaryClassName}>{secondary}</p>}
    </div>
  );
}
